var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 84,
    viewBox: "0 0 216 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.482 83 .002-7.79h8.216v-6.425c5.539-.97 12.015-3.562 17.543-10.392.985-1.216 1.707-4.372 2.165-9.466.226-2.524.397-7.112.511-13.764H140V17.58h-14.5V3h81.446c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8h-55.368Zm0 0H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 67 0 63.418 0 59s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h51.737c-5 0-9.054-3.582-9.054-8s4.053-8 9.054-8H96.5v14.581H82v17.582h.016c.135 13.249 1.093 20.992 2.876 23.23 5.247 6.588 11.956 9.228 17.408 10.272v6.544h9.182V83Zm-5.315-80h9.666v14.581h-9.666V3Zm100.78 48c-5.001 0-9.055-3.582-9.055-8s4.054-8 9.054-8S216 38.582 216 43s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.499 74.573a4364.527 4364.527 0 0 1 0 8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M82 17.581v17.582h58V17.58H111.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55 69.622h14.9v4.337h-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.008 29.302c-.109 16.844.853 26.541 2.884 29.091 8.136 10.215 19.786 10.938 24.819 10.938 5.427 0 17.915.944 27.532-10.938.985-1.216 1.707-4.372 2.165-9.466.288-3.207.485-9.75.592-19.625H82.008Z",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.083 3.167v14.141h7.167V3.168c-1.273-1.306-2.466-1.918-3.583-1.918-1.118 0-2.311.612-3.584 1.917ZM97.75 3.167v14.141h7.167V3.168c-1.273-1.306-2.466-1.918-3.584-1.918-1.117 0-2.31.612-3.583 1.917Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.ee39cf8d5c8e81bf1ee0ae4ffbb468f3.svg";
export { ForwardRef as ReactComponent };